import { render } from "./ProjectMenu.vue?vue&type=template&id=39b0dcbb&scoped=true"
import script from "./ProjectMenu.vue?vue&type=script&lang=js"
export * from "./ProjectMenu.vue?vue&type=script&lang=js"

import "./ProjectMenu.vue?vue&type=style&index=0&id=39b0dcbb&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b0dcbb"]])

export default __exports__